// extracted by mini-css-extract-plugin
export default {"icon":"WidgetResizeIcon__icon--dSt_M"};